module.exports = __webpack_public_path__ + "img/Slider-AUTO_fr.27a7ea8b.png";